import { Card, CardBody, CardFooter, CardTitle, Col, Row } from "reactstrap";
import Select from "react-select";
import { useMemo } from "react";

const ItemsPerPage = props => {
  return (
    <div className="form-floating mb-3">
      <select
        className="form-select"
        id="itemsPerPageSelect"
        value={props.value}
        onChange={e => props.handleItemsPerPage(e.target.value)}
      >
        <option value={0} disabled>
          Items per Page
        </option>
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
      </select>
      <label htmlFor="itemsPerPageSelect" className="w-100 text-ellipsis text-secondary">
        Items per page
      </label>
    </div>
  )
}
const DataFilter = ({ label, options, value, onChange, style, ...props }) => {

  const pluralLabel = useMemo(() => {
    if (!label) return '';
  
    const lower = label.toLowerCase();
    console.log("pluralLabel", lower)
    if (lower === 'user status') { console.log("status plural"); return 'Status'};
    if (lower === 'country') return 'Countries';
    if (lower === 'staff') return 'Staffs';
    
    return `${label}s`;
  }, [label]);

  return (
    <div className="form-floating mb-3" style={{ ...style }}>
      <select
        className="form-select"
        id="dataFilterSelect"
        value={value}
        onChange={onChange}
        {...props}
      >
        <option key="" value="">
          All {pluralLabel}
        </option>
        {options?.map(option => (
          <option key={option?.id} value={option?.id}>
            {option?.name}
          </option>
        ))}
      </select>
      <label htmlFor="dataFilterSelect" className="w-100 text-ellipsis text-secondary">
        {label}
      </label>
    </div>
  )
}
const DataFilterColoredOptions = ({ label, options, value, onChange, style, ...props }) => {
  return (
    <div className="form-floating mb-3" style={{ ...style }}>
      <select
        className="form-select"
        id="dataFilterSelect"
        value={value}
        onChange={onChange}
        {...props}
      >
        {/* <option key="" value="">
          All
        </option> */}
        {options?.map(option => (
          <option key={option?.id} value={option?.id} style={{backgroundColor: option?.bgClr ? option?.bgClr : null}}>
            {option?.name}
          </option>
        ))}
      </select>
      <label htmlFor="dataFilterSelect" className="w-100 text-ellipsis text-secondary">
        {label}
      </label>
    </div>
  )
}
// Reusable select filter with a controllable default (placeholder) option.
// Unlike DataFilter, the default label is passed in (e.g. "All", "None"),
// so it reads cleanly for any field.
const SelectFilter = ({
  label,
  options,
  value,
  onChange,
  placeholder = "All",
  style,
  ...props
}) => {
  return (
    <div className="form-floating mb-3" style={{ ...style }}>
      <select
        className="form-select"
        value={value}
        onChange={onChange}
        {...props}
      >
        <option value="">{placeholder}</option>
        {options?.map(option => (
          <option key={String(option?.id)} value={option?.id}>
            {option?.name}
          </option>
        ))}
      </select>
      <label className="w-100 text-ellipsis text-secondary">{label}</label>
    </div>
  )
}

const SearchFilter = ({ label, value, onChange, style, ...props }) => {
  return (
    <div className="form-floating mb-3" style={{ ...style }}>
      <input
        className="form-control"
        id="dataSearch"
        placeholder="Type to Search"
        type="text"
        value={value}
        onChange={onChange}
        {...props}
      />
      <label htmlFor="dataSearch" className="w-100 text-ellipsis text-secondary">
        {label}
      </label>
    </div>
  )
}

const FilterStaff = ({ options,label, value, onChange, style, ...props }) =>{
  // console.log("Staff Transformed options:", options);
  return (
    <div className="form-floating mb-3" style={{ ...style}}>
    <select
      className="form-select"
      value={value}
      onChange={onChange}
    >
      <option key="" value="" selected>
        All
      </option>
      {options?.map(option => (
        <option key={option?.id} value={option?.id}>
          {option?.name}
        </option>
      ))}
    </select>
    <label htmlFor="dataFilterSelect" className="w-100 text-ellipsis text-secondary">
      {label}
    </label>
  </div>
  )
}

// style={{backgroundColor: option?.bgClr ? option?.bgClr : null}}


export { ItemsPerPage, DataFilter, DataFilterColoredOptions, SearchFilter, SelectFilter, FilterStaff }

